import * as permissions from '@/shared/user/permissions'

export const roles: Record<string, string> = {
  ROLE_CMS_ADMIN: 'CMS-Admin',
  ROLE_TEXTBOOK_ADMIN: 'Lehrwerk-Admin',
  ROLE_TEXTBOOK_ISSUE_EDITOR: 'Lehrwerksteil-Redakteur',
  ROLE_TEXTBOOK_ISSUE_READER: 'Lehrwerksteil-Leser',
}

export const accessList = {
  [permissions.VIEW_USER_MANAGEMENT]: [roles.ROLE_CMS_ADMIN],
  [permissions.VIEW_LICENSE_MANAGEMENT]: [roles.ROLE_CMS_ADMIN],
  [permissions.CREATE_TEXTBOOK]: [roles.ROLE_CMS_ADMIN, roles.ROLE_TEXTBOOK_ADMIN],
  [permissions.EDIT_TEXTBOOK]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.DELETE_TEXTBOOK]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.CREATE_TEXTBOOK_ISSUE]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.EDIT_TEXTBOOK_ISSUE]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.DELETE_TEXTBOOK_ISSUE]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.IMPORT_TEXTBOOK_ISSUE]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.UPLOAD_MEDIA_ITEM]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.EDIT_MEDIA_ITEM]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.DELETE_MEDIA_ITEM]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.CREATE_MEDIA_ITEM_OCCURENCE]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
    roles.ROLE_TEXTBOOK_ISSUE_EDITOR,
  ],
  [permissions.EDIT_MEDIA_ITEM_OCCURENCE]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
    roles.ROLE_TEXTBOOK_ISSUE_EDITOR,
  ] as string[],
  [permissions.DELETE_MEDIA_ITEM_OCCURENCE]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
    roles.ROLE_TEXTBOOK_ISSUE_EDITOR,
  ],
  [permissions.REORDER_MEDIA_ITEM_OCCURENCES]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
    roles.ROLE_TEXTBOOK_ISSUE_EDITOR,
  ],
  [permissions.CREATE_CATEGORY]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.EDIT_CATEGORY]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.DELETE_CATEGORY]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.REORDER_CATEGORIES]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.PUBLISH_TEXTBOOK_ISSUE_LIVE]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
  ],
  [permissions.PUBLISH_TEXTBOOK_ISSUE_PREVIEW]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
    roles.ROLE_TEXTBOOK_ISSUE_EDITOR,
  ],
  [permissions.PREVIEW_TEXTBOOK_ISSUE]: [
    // right to view preview
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN,
    roles.ROLE_TEXTBOOK_ISSUE_EDITOR,
    roles.ROLE_TEXTBOOK_ISSUE_READER,
  ],
  [permissions.CREATE_VOLUME]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN
  ],
  [permissions.EDIT_VOLUME]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN
  ],
  [permissions.DELETE_VOLUME]: [
    roles.ROLE_CMS_ADMIN,
    roles.ROLE_TEXTBOOK_ADMIN
  ],
}
